import React, { useEffect, useState } from "react";
import MultiSelectCheckboxGroup from "./MultiSelectCheckboxGroup";
import { financialOptions, valueOptions } from "../../constants/dataConstants";

interface Props {
  setPartnerDetails: any;
  selectedValueServices: any;
  setSelectedValueServices: any;
  selectedFinancial: any;
  setSelectedFinancial: any;
  editPartnerData: any;
  setEditPartnerData: any;
}

const AdditionalOfferings = (props: Props) => {
  const {
    setPartnerDetails,
    selectedValueServices,
    setSelectedValueServices,
    selectedFinancial,
    setSelectedFinancial,
    editPartnerData,
    setEditPartnerData,
  } = props;
  const [valueServicesChecked, setValueServicesChecked] = useState(true);
  const [valueOther, setValueOther] = useState("");
  // const [selectedFinancial, setSelectedFinancial] = useState<string[]>([]);
  const [financialChecked, setFinancialChecked] = useState(true);
  const [financialOther, setFinancialOther] = useState("");
  // const [selectedValueServices, setSelectedValueServices] = useState<string[]>(
  //   []
  // );
  // const [additionalOfferingData, setAdditionalOfferingData] = useState<any>({});

  useEffect(() => {
    if (editPartnerData && Object.keys(editPartnerData).length) {
      setSelectedValueServices(editPartnerData?.value_added_services || []);
      setSelectedFinancial(editPartnerData?.financial_assistance || []);
    }
  }, [editPartnerData]);

  useEffect(() => {
    // setAdditionalOfferingData((prev: any) => ({
    //   ...prev,
    //   valueAddedService: selectedValueServices,
    //   financialAssistance: selectedFinancial,
    // }));

    setPartnerDetails((prev: any) => ({
      ...prev,
      value_added_services: selectedValueServices,
      financial_assistance: selectedFinancial,
    }));
  }, [selectedValueServices, selectedFinancial]);

  const toggleValueService = (option: string) => {
    if (selectedValueServices.includes(option)) {
      setSelectedValueServices(
        selectedValueServices.filter((item: any) => item !== option)
      );
    } else {
      setSelectedValueServices([...selectedValueServices, option]);
    }
  };

  const toggleFinancial = (option: string) => {
    if (selectedFinancial.includes(option)) {
      setSelectedFinancial(
        selectedFinancial.filter((item: any) => item !== option)
      );
    } else {
      setSelectedFinancial([...selectedFinancial, option]);
    }
  };

  return (
    <div className="flex flex-col gap-[32px]">
      <MultiSelectCheckboxGroup
        label="Value Added Services"
        options={valueOptions}
        selected={selectedValueServices}
        setSelected={setSelectedValueServices}
        checked={valueServicesChecked}
        setChecked={setValueServicesChecked}
        otherInputValue={valueOther}
        setOtherInputValue={setValueOther}
        toggleSelection={toggleValueService}
        showCheckBox={false}
      />

      <MultiSelectCheckboxGroup
        label="Financial Assistance"
        options={financialOptions}
        selected={selectedFinancial}
        setSelected={setSelectedFinancial}
        checked={financialChecked}
        setChecked={setFinancialChecked}
        otherInputValue={financialOther}
        setOtherInputValue={setFinancialOther}
        toggleSelection={toggleFinancial}
        showCheckBox={false}
      />
    </div>
  );
};

export default AdditionalOfferings;
